<template>
	<ProjectMonitoringFormView :readOnly="true"/>
</template>

<script>

	import ProjectMonitoringFormView from "./ProjectMonitoringFormView";

	export default {
		name: "ProjectMonitoringReadOnlyView",
		components: {ProjectMonitoringFormView}
	};
</script>

<style scoped>

</style>
